import { IconEyeOff, IconTrash } from '@tabler/icons-react';
import { memo, useCallback } from 'react';
import PlayerMenuTooltip from '../PlayerMenus/PlayerMenuTooltip';
import { SelectionOutlineAction } from '../Outlines/types';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import { toggleSpeakerLabels } from '@/stores/clip';
import EventBus from '@/libs/eventBus/eventBus';
import { CustomEvents } from '@/libs/eventBus/constants';
import { isClipAudiogram } from '@/player-config/src/utils/clipUtils';

function SpeakerLabelRemoveButton() {
  const { clipId, clipData } = useClipsContext();

  const isAudiogram = isClipAudiogram(clipData);
  const useAnimatedSpeakerCards = !isAudiogram;

  const removeSpeakerLabel = useCallback(() => {
    toggleSpeakerLabels(clipId, false);
    EventBus.dispatch(CustomEvents.SelectionOutlineAction, {
      action: SelectionOutlineAction.DESELECT
    });
  }, [clipId]);

  return (
    <button
      onClick={removeSpeakerLabel}
      data-testid="speaker-label-remove-button"
      className="group/button flex size-10 items-center justify-center rounded-md hover:bg-slate-100"
    >
      {useAnimatedSpeakerCards ? <IconEyeOff size={20} /> : <IconTrash size={20} />}
      <PlayerMenuTooltip content={useAnimatedSpeakerCards ? 'Hide' : 'Remove'} />
    </button>
  );
}

export default memo(SpeakerLabelRemoveButton);
